<template>
    <button
        class="btn flex items-center gap-1"
        @click="followUser"
        :disabled="isProcessing"
        :class="{ 'opacity-50 cursor-not-allowed': isProcessing }"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="size-5"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M18 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0ZM3 19.235v-.11a6.375 6.375 0 0 1 12.75 0v.109A12.318 12.318 0 0 1 9.374 21c-2.331 0-4.512-.645-6.374-1.766Z"
            />
        </svg>
        {{ isProcessing ? "Processing..." : buttonText }}
    </button>
</template>

<script>
import axios from "axios";

export default {
    props: {
        userId: {
            required: true,
            type: Number,
        },
        follows: {
            required: true,
            type: Boolean,
        },
    },

    data() {
        return {
            status: this.follows,
            isProcessing: false,
        };
    },

    methods: {
        async followUser() {
            if (this.isProcessing) return;

            this.isProcessing = true;
            const config = {
                headers: {
                    "X-CSRF-TOKEN": document
                        .querySelector('meta[name="csrf-token"]')
                        .getAttribute("content"),
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            };

            try {
                const response = await axios.post(
                    `/follow/${this.userId}`,
                    {},
                    config
                );

                if (response.data.success) {
                    this.status = response.data.follows;
                    this.$emit(
                        "followers-updated",
                        response.data.followersCount
                    );
                    window.location.reload();
                }
            } catch (error) {
                console.error("Follow error:", error.response?.data || error);
                if (error.response?.status === 401) {
                    window.location = "/login";
                }
            } finally {
                this.isProcessing = false;
            }
        },
    },

    computed: {
        buttonText() {
            return this.status ? "Unfollow" : "Follow";
        },
    },
};
</script>
